import React from 'react';
import I18n from '../../I18n/I18n/I18n';
function toI18n(text) {
  return {
    i18n: {
      id: text
    },
    escape: true
  };
}
function getDescriptiveText(description) {
  if (!description) {
    return null;
  }
  var descriptions = Array.isArray(description) ? description : [description];
  return descriptions.map(function (value, index) {
    var description = typeof value === 'string' ? toI18n(value) : value;
    if (!description.href && description.i18n && description.escape) {
      return /*#__PURE__*/React.createElement(I18n, {
        key: index,
        i18n: description.i18n
      });
    }
    return null;
  });
}
export default function InlineDescription(_ref) {
  var description = _ref.description,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    className: "assistive-text"
  }, getDescriptiveText(description));
}